// extracted by mini-css-extract-plugin
export default {"contentSection":"ProductGroupsGISMT_contentSection__Hmcst"};